export default {
      id: "ic-para-marianne-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-para-marianne-usage",
      toString: function () {
        return this.url;
      }
    }